import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  ProgressEntity,
  ProgressKey,
  servicesProgressEntities,
} from '../types/services-progress-entities';

export enum Flow {
  ServiceOrder = 'SERVICE_ORDER',
  ServiceVacationHome = 'SERVICE_VACATION_HOME',
  FiberInquiry = 'FIBER_INQUIRY',
  FiberOrder = 'FIBER_ORDER',
  FiberUpdateContactInfo = 'FIBER_UPDATE_CONTACT_INFORMATION',
  FiberUpdate = 'FIBER_UPDATE',
  NotSet = '',
}

@Injectable({ providedIn: 'root' })
export class ProgressService {
  private progressStatus = new BehaviorSubject<ProgressEntity>(
    {} as ProgressEntity
  );
  private activeFlow = new BehaviorSubject<Flow>(Flow.NotSet);

  public getActiveFlow$(): Observable<Flow> {
    return this.activeFlow.asObservable();
  }

  public setActiveFlow(flow: Flow) {
    this.activeFlow.next(flow);
  }

  public getProgressStep$(): Observable<ProgressEntity> {
    return this.progressStatus.asObservable();
  }

  public setProgressStep(key: ProgressKey) {
    this.progressStatus.next(
      servicesProgressEntities.find((entity) => entity.key === key) ??
        ({} as ProgressEntity)
    );
  }
}
